import { useState } from "react";

import Logo          from "../../asset/images/footer/logo.svg";
import PhoneIcon     from "../../asset/images/footer/phone-icon.svg";
import MailIcon      from "../../asset/images/footer/mail-icon.svg";
import LinkedInIcon  from "../../asset/images/footer/linkedin-icon.svg";
import YouTubeIcon   from "../../asset/images/footer/youtube-icon.svg";

/* ─── Constants ─── */
const RED       = "#EB2019";
const FOOTER_BG = "#202020";
const DIVIDER   = "rgba(255,255,255,0.12)";
const LINK_CLR  = "#fff";

const BUSINESSES = [
  { label: "Clean Air",                      path: "/products" },
  { label: "Traffic & Inforcement",          path: "https://adortraffic.com/" },
  { label: "Hydrogen Power Source",          path: "https://yonderh2.com/" },
  { label: "Power & Surveillance Solutions", path: "/power-surveillance/hp-series" },
  { label: "Defence",                        path: "/defence/ador-defence" },
  { label: "Software Innovation",            path: "/software-innovation" },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

  .pwr-footer *, .pwr-footer *::before, .pwr-footer *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .pwr-footer {
    background: ${FOOTER_BG};
    color: #fff;
    font-family: 'Poppins', sans-serif;
  }

  /* ── Main body ── */
  .pwr-footer-body {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 32px;
    display: grid;
    grid-template-columns: 280px 270px 1fr;
    gap: 0 144px;
    align-items: flex-start;
    border-bottom: 1px solid #525252;
  }

  /* ── Brand column ── */
  .pwr-footer-logo-row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  .pwr-footer-logo-img {
    height: 100px;
    width: auto;
    object-fit: contain;
  }

  .pwr-footer-tagline {
    font-size: 11px;
    font-weight: 400;
    color: rgba(255,255,255,0.45);
    letter-spacing: 0.4px;
    margin-bottom: 20px;
  }

  .pwr-footer-brand-divider {
    width: 100%;
    height: 1px;
    background: ${DIVIDER};
    margin: 30px 0;
  }

  /* Socials — desktop version (below divider) */
  .pwr-footer-socials {
    display: flex;
    gap: 14px;
    margin-bottom: 20px;
  }

  /* Socials — mobile version (beside logo), hidden on desktop */
  .pwr-footer-socials-mobile {
    display: none;
  }

  .pwr-social-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;
    flex-shrink: 0;
    transition: opacity 0.2s;
  }

  .pwr-social-btn:hover { opacity: 0.82; }

  .pwr-social-svg {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }

  /* Contact */
  .pwr-footer-contact {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .pwr-contact-item {
    display: flex;
    align-items: center;
    gap: 14px;
    text-decoration: none;
    color: ${LINK_CLR};
    font-size: 16px;
    font-weight: 400;
    transition: color 0.2s;
  }

  .pwr-contact-item:hover { color: #fff; }

  .pwr-contact-svg {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  /* Contact divider — hidden on desktop */
  .pwr-footer-contact-divider {
    display: none;
  }

  /* ── Businesses column ── */
  .pwr-footer-col-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    margin-bottom: 15px;
    letter-spacing: 0;
    margin-top:10px;
  }

  .pwr-footer-links {
    display: flex;
    flex-direction: column;
    gap: 21px;
    list-style: none;
  }

  .pwr-footer-links li a {
    text-decoration: none;
    color: #9A9A9A;
    font-size: 16px;
    font-weight: 400;
    line-height: 120%;
    transition: color 0.2s;
  }

  .pwr-footer-links li a:hover { color: #B71C1C; }

  .pwr-business-link {
    text-decoration: none;
    color: ${LINK_CLR};
    font-size: 13.5px;
    font-weight: 400;
    line-height: 1.4;
    transition: color 0.2s;
  }

  .pwr-business-link:hover { color: rgba(255,255,255,0.70); }

  /* ── Newsletter column ── */
  .pwr-newsletter-desc {
    font-size: 16px;
    font-weight: 400;
    color: #9A9A9A;
    margin-bottom: 30px;
    line-height: 1.5;
  }

  .pwr-newsletter-field {
    display: block;
    width: 277px;
    background: #202020;
    border: 1px solid #8C8C8C;
    border-radius: 10px;
    padding: 11.5px 24px;
    color:#fff;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 200;
    outline: none;
    margin-bottom: 14px;
    transition: border-color 0.2s;
  }

  .pwr-newsletter-field::placeholder { color: #fff; }
  .pwr-newsletter-field:focus { border-color: rgba(255,255,255,0.32); }

  .pwr-subscribe-btn {
    background: ${RED};
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    cursor: pointer;
    transition: opacity 0.2s;
    letter-spacing: 0.1px;
    margin-top:6px;
  }

  .pwr-subscribe-btn:hover { background: #B71C1C;  }

  /* ── Copyright bar ── */
  .pwr-footer-bar {
    // border-top: 1px solid ${DIVIDER};
  }

  .pwr-footer-bar-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 30px 102px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pwr-footer-copy {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    letter-spacing: 0.1px;
  }

  .pwr-footer-brand { max-width: 219px; }
  .typo:hover{color:#EB2019;}

  /* ── Responsive ── */
  @media (max-width: 1100px) {
    .pwr-footer-body {
      padding: 48px 48px 40px;
      gap: 0 36px;
    }
    .pwr-footer-bar-inner { padding: 16px 48px; }
  }

  @media (max-width: 820px) {
    .pwr-footer-body {
      padding: 40px 32px 32px;
      grid-template-columns: 1fr 1fr;
      gap: 36px 24px;
    }
    .pwr-footer-brand { grid-column: 1 / -1; }
    .pwr-footer-bar-inner { padding: 14px 32px; }
  }

  /* ══════════════════════════════════════════
     MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .pwr-footer-body {
      padding: 16px 16px 20px 16px;
      grid-template-columns: 1fr;
      gap: 0;
      border-bottom: 1px solid rgba(255,255,255,0.2);
    }

    /* Brand block */
    .pwr-footer-brand {
      grid-column: 1 / -1;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      padding-bottom: 0px;
    }

    /* Logo row: logo left, mobile socials right */
    .pwr-footer-logo-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0;
    }

    .pwr-footer-logo-img { height: 64px; }

    /* Hide desktop socials, show mobile socials */
    .pwr-footer-socials        { display: none; }
    .pwr-footer-socials-mobile { display: flex; gap: 30px; }

    .pwr-footer-socials-mobile .pwr-social-svg { width: 30px; height: 30px; }

    /* Divider below logo row */
    .pwr-footer-brand-divider {
      margin: 30px 0;
      background: rgba(255,255,255,0.2);
    }

    /* Contact row: phone + email side by side */
    .pwr-footer-contact {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 34px;
      flex-wrap: wrap;
      width: 100%;
    }

    .pwr-contact-item { font-size: 14px; gap: 8px; }
    .pwr-contact-svg  { width: 21px; height: 21px; }

    /* Divider after contact — shown on mobile only */
    .pwr-footer-contact-divider {
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(255,255,255,0.2);
      margin: 20px 0;
      display:none;
    }

    /* Businesses + Newsletter sections */
    .pwr-footer-body > div:nth-child(2),
    .pwr-footer-body > div:nth-child(3) {
      padding: 30px 0 0 0;
    }

    .pwr-footer-col-title {
      margin-top: 0;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 14px;
    }

    .pwr-footer-links { gap: 14px; }
    .pwr-footer-links li a { font-size: 14px; color: #9A9A9A; }

    .pwr-newsletter-desc {
      font-size: 14px;
      margin-bottom: 10px;
      color: #9A9A9A;
    }

    .pwr-newsletter-field {
      width: 100%;
      padding: 11px 20px;
      margin-bottom: 15px;
      border-radius: 8px;
      font-size: 14px;
      font-weight:300;
    }

    .pwr-subscribe-btn {
      width: 100%;
      font-size: 14px;
      border-radius: 5px;
      padding: 9px 20px;
      margin-top: 0;
    }

    .pwr-footer-bar-inner { padding: 20px 20px; }
    .pwr-footer-copy { font-size: 12px; text-align: center; }
  }
`;

/* ─── Component ─── */
export default function PowertronFooter() {
  const [name,  setName]  = useState("");
  const [email, setEmail] = useState("");

  const SocialIcons = ({ className }) => (
    <div className={className}>
      <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="pwr-social-btn" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
        <img src={LinkedInIcon} alt="LinkedIn" className="pwr-social-svg" />
      </a>
      <a href="https://www.youtube.com/@adorIndia" className="pwr-social-btn" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
        <img src={YouTubeIcon} alt="YouTube" className="pwr-social-svg" />
      </a>
    </div>
  );

  return (
    <>
      <style>{CSS}</style>

      <footer className="pwr-footer">

        {/* ── Main grid ── */}
        <div className="pwr-footer-body">

          {/* Col 1: Brand */}
          <div className="pwr-footer-brand">

            <div className="pwr-footer-logo-row">
  <a href="/">
    <img src={Logo} alt="Ador Logo" className="pwr-footer-logo-img" />
  </a>
  <SocialIcons className="pwr-footer-socials-mobile" />
</div>
            <div className="pwr-footer-brand-divider" />

            {/* Desktop socials — shown below divider on desktop, hidden on mobile */}
            <SocialIcons className="pwr-footer-socials" />

            <div className="pwr-footer-contact">
              <a href="tel:+912027472532" className="pwr-contact-item">
                <img src={PhoneIcon} alt="Phone" className="pwr-contact-svg" />
                +91-20-27472532
              </a>
              <a href="mailto:info@adorpower.com" className="pwr-contact-item">
                <img src={MailIcon} alt="Email" className="pwr-contact-svg" />
                info@adorpower.com
              </a>
            </div>

            {/* Divider after contact — mobile only */}
            <div className="pwr-footer-contact-divider" />
          </div>

          {/* Col 2: Businesses */}
          <div>
            <div className="pwr-footer-col-title">Businesses</div>
            <ul className="pwr-footer-links">
              {BUSINESSES.map((b) => (
                <li key={b.label}>
                  <a
                    href={b.path}
                    className="pwr-business-link"
                    {...(b.path.startsWith("https://") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  >
                    {b.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Newsletter */}
          <div>
            <div className="pwr-footer-col-title">Newsletter</div>
            <p className="pwr-newsletter-desc">Get The Latest News And Updates</p>

            <input
              className="pwr-newsletter-field"
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className="pwr-newsletter-field"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button className="pwr-subscribe-btn">Subscribe</button>
          </div>

        </div>

        {/* ── Copyright bar ── */}
        <div className="pwr-footer-bar">
  <div className="pwr-footer-bar-inner">
    <span className="pwr-footer-copy">
      Copyright &copy; 2026 Ador Group. All Right Reserved. Designed & Developed by{" "}
      <a
        href="https://eilandigital.com/"
        style={{ color: "#0000EE", textDecoration: "none" }}
        onMouseOver={(e) => (e.target.style.color = "#B71C1C")}
        onMouseOut={(e) => (e.target.style.color = "#046bd2")  } target="_blank"
      >
        Eilan Digital
      </a>
    </span>
  </div>
</div>

      </footer>
    </>
  );
}